import React, { useState, useEffect } from "react";
import   Landmark   from "../../assets/icons/popup/GCASH-Logo.svg?react";

import { CircleUserRound } from "lucide-react";

export default function LinkGCashPopup({ isOpen, onClose }) {
  const [visible, setVisible] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setVisible(true); // Add popup to DOM
      setTimeout(() => setMounted(true), 10); // Add slight delay for animation to start
    } else {
      setMounted(false); // Trigger exit animation
      setTimeout(() => setVisible(false), 300); // Remove from DOM after animation
    }
  }, [isOpen]);

  if (!visible) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-end justify-center px-4 z-[60] font-poppins">
      <div
        className={`relative z-20 w-full max-w-sm bg-white rounded-t-2xl p-6 transform transition-transform duration-300 ${
          mounted ? "translate-y-0" : "translate-y-full"
        }`}
      >
        {/* Header */}
        <div className="mb-4">
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 float-end"
            aria-label="Close"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <h2 className="text-sm font-normal text-center">Link E-Wallet</h2>
        </div>

        {/* GCash Logo */}
        <div className="flex items-center justify-center gap-2 mb-4">
          <div className="flex items-center justify-center">
            <Landmark className="w-40"/>
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <div className="relative">
              <div className="absolute left-1 bg-transparent top-1/2 -translate-y-1/2 p-2 border-r border-gray-400 ">
                <CircleUserRound className="text-blue-700" />
              </div>
              <input
                type="text"
                className="w-full text-sm pl-12 pr-4 py-3 border border-gray-400 rounded-lg "
                placeholder="Account Number"
                required
              />
            </div>
          </div>

          <div className="flex gap-3">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 p-2 border border-blue-600 text-blue-600 text-sm rounded-lg hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 p-2 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-600 transition-colors"
            >
              Add Account
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
